import React from 'react';
import PropTypes from 'prop-types';
import { get, noop } from 'lodash';
import styled from 'styled-components';
import { em } from 'polished';
import Button from '../Button';
import { Form, FormButtons } from '../form';
import ErrorMessage from '../ErrorMessage';
import SuccessMessage from '../SuccessMessage';
import { appTheme } from '../../../theme';

const LargeButton = styled(Button)`
  align-self: center;
  margin-top: calc(${appTheme.spacing.default} * 2);
  width: ${em('350px')};
`;

const CenteredFormButtons = styled(FormButtons)`
  justify-content: center;
`;

class StaticFormLayout extends React.Component {
  handleCancel = () => {
    this.props.resetForm();
    this.props.onCancel();
  };

  render() {
    const {
      children,
      handleSubmit,
      isSubmitting,
      setStatus,
      status,
      submitButtonText,
    } = this.props;

    const hasSaved = get(status, 'hasSaved');
    const saveError = get(status, 'saveError');
    return (
      <Form onSubmit={handleSubmit}>
        {children}
        {saveError && <ErrorMessage>{saveError}</ErrorMessage>}
        {hasSaved && (
          <SuccessMessage
            isOpen={true}
            message="Saved!"
            onExited={() => setStatus({ hasSaved: false })}
          />
        )}
        <CenteredFormButtons>
          <LargeButton disabled={isSubmitting} type="submit">
            {submitButtonText || 'Save'}
          </LargeButton>
        </CenteredFormButtons>
      </Form>
    );
  }
}

StaticFormLayout.propTypes = {
  children: PropTypes.node.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,

  onCancel: PropTypes.func,
  status: PropTypes.object,
  submitButtonText: PropTypes.string,
};

StaticFormLayout.defaultProps = {
  onCancel: noop,
  status: {},
  submitButtonText: undefined,
};

export default StaticFormLayout;



// WEBPACK FOOTER //
// ./src/modules/common/layouts/StaticFormLayout.js